var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjDivider", { attrs: { "right-fixed": "" } }, [
        _vm._v("Storage Report"),
      ]),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "Customer", label: "Customer", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "Year", label: "Year", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "Week", label: "Week", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "Start", label: "Start Time", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "End", label: "End Time", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "Amount",
              label: "Storage Pallet Amount",
              align: "center",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }